module.exports = __webpack_public_path__ + "assets/img/2_795_big.e9576a0b.jpg";